import { useState, useCallback, useEffect } from "react";
import { APIError, useAxios } from "../core/_axios";
import { managementCreateStripeCheckoutSessionForSpecificAccount } from "../core/_requests";
import { createStripeCheckoutSessionForCurrentAccount } from "../core/_requests_v2";

function useStripeCheckoutSession({
    isSubscribed,
    accountUniqueId,
    selectedPlanId
}: {
    isSubscribed: boolean,
    accountUniqueId?: string | null,
    selectedPlanId?: string | null
}) {

    const axios = useAxios();

    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState<string | null>(null);
    const [checkoutSessionClientSecret, setCheckoutSessionClientSecret] = useState<string | null>(null);

    const loadStripeCheckoutSession = useCallback(async () => {
        if (isSubscribed) {
            return;
        }
        if (!selectedPlanId) {
            return;
        }
        setLoading(true);
        setLoadingError(null);
        setCheckoutSessionClientSecret(null);
        try {
            if (accountUniqueId) {
                const updateCheckoutSessionClientSecret = await managementCreateStripeCheckoutSessionForSpecificAccount(
                    axios,
                    accountUniqueId,
                    {
                        planId: selectedPlanId
                    }
                );
                setCheckoutSessionClientSecret(updateCheckoutSessionClientSecret);
            } else {
                const updateCheckoutSessionClientSecret = await createStripeCheckoutSessionForCurrentAccount(
                    axios,
                    {
                        planId: selectedPlanId
                    }
                );
                setCheckoutSessionClientSecret(updateCheckoutSessionClientSecret);
            }
        } catch (exception) {
            console.error(exception)
            const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
            setLoadingError(errorMessage)
        } finally {
            setLoading(false)
        }
    }, [axios, isSubscribed, selectedPlanId, accountUniqueId]);

    useEffect(() => {
        loadStripeCheckoutSession();
    }, [loadStripeCheckoutSession]);

    return {
        loading,
        loadingError,
        checkoutSessionClientSecret,
        onRetry: loadStripeCheckoutSession
    }

}

export default useStripeCheckoutSession;